import { render, staticRenderFns } from "./DesignSetting.vue?vue&type=template&id=7b1d47c4&scoped=true"
import script from "./DesignSetting.vue?vue&type=script&lang=js"
export * from "./DesignSetting.vue?vue&type=script&lang=js"
import style0 from "./DesignSetting.vue?vue&type=style&index=0&id=7b1d47c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1d47c4",
  null
  
)

export default component.exports